import { useState } from "react";

import { usePreventLeaveSite } from "@/lib/hooks/usePreventLeaveSite";
import { Button2 } from "@/ui2/atoms/Button";

import { CancellationModal } from "./CancellationModal";

export function AssessmentCancelButton({
  isDirty,
  isSubmitting,
}: {
  isDirty?: boolean;
  isSubmitting?: boolean;
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const shouldPreventNavigation = isDirty && !isSubmitting;

  usePreventLeaveSite({
    isEnabled: shouldPreventNavigation,
  });

  return (
    <>
      <Button2 onPress={() => setIsModalOpen(true)} type="button" variant="secondary">
        Cancel
      </Button2>

      <CancellationModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
    </>
  );
}
